module.exports = __webpack_public_path__ + "static/media/27.15cae73e.jpg";